import React, { useEffect } from "react";
import { ITableUI } from "../TableTemplate/tableTemplate";
import { IConnectionsReport } from "../../Interfaces/connections";
import { CommonTableUI } from "../TableTemplate/common";
import { ConnectionTableAdditional } from "./ConnectionTableAdditional";
import { useAppDispatch, useAppSelector } from "../../App/hooks";
import { setSahraConnectionsTableFetchDataFlag } from "../../Features/SahraConnections/SahraConnectionsSlice";

const TableUI: React.FC<ITableUI<IConnectionsReport>> = ({
  reports,
  onAction,
}: ITableUI<IConnectionsReport>) => {
  const flag = useAppSelector((store) => store.sahraConnections.tableFetchFlag);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!!flag && onAction) {
      dispatch(setSahraConnectionsTableFetchDataFlag(false));
      onAction();
    }
  }, [flag]);

  return (
    <CommonTableUI
      onAction={onAction}
      AdditionalBody={ConnectionTableAdditional}
      tableBoxClassName="!w-full !max-w-none max-h-[500px]"
      reports={reports}
      hideWhenNoResp
    />
  );
};

export default TableUI;
